import defaultSettings from '@/settings'
import { useDynamicTitle } from '@/utils/dynamicTitle'
import { getThemeMode, applyThemeMode } from '@/utils/theme'

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''

// 应用启动时已保存的明暗模式（index.html 内联脚本已提前应用 dark class，这里只需读取用于同步 store 状态）
const initialThemeMode = getThemeMode()

const useSettingsStore = defineStore(
  'settings',
  {
    state: () => ({
      title: '',
      theme: storageSetting.theme || '#CC251B',
      // 明暗模式：dark 时侧边栏强制使用深色配色，与全局深色令牌保持一致
      themeMode: initialThemeMode,
      sideTheme: initialThemeMode === 'dark' ? 'theme-dark' : (storageSetting.sideTheme || sideTheme),
      showSettings: showSettings,
      topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
      tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
      fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
      sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
      dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle
    }),
    actions: {
      // 修改布局设置
      changeSetting(data) {
        const { key, value } = data
        if (this.hasOwnProperty(key)) {
          this[key] = value
        }
      },
      // 设置网页标题
      setTitle(title) {
        this.title = title
        useDynamicTitle();
      },
      // 切换明暗模式，并联动侧边栏深浅配色
      toggleThemeMode() {
        const next = this.themeMode === 'dark' ? 'light' : 'dark'
        this.themeMode = applyThemeMode(next)
        this.sideTheme = next === 'dark' ? 'theme-dark' : 'theme-light'
      }
    }
  })

export default useSettingsStore
